/* eslint-disable @typescript-eslint/no-var-requires, unicorn/prefer-module */
import React from 'react';

if (process.env.ENVIRONMENT === 'test' && typeof window !== 'undefined') {
  const whyDidYouRender = require('@welldone-software/why-did-you-render');
  whyDidYouRender(React, {
    trackAllPureComponents: true,
  });
}
